const portalId: number = parseInt(process.env.GATSBY_PORTAL_ID as string, 10);

export {
  portalId,
};
